var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("label", { attrs: { for: _vm.handle } }, [_vm._v(_vm._s(_vm.label))]),
    _vm._v(" "),
    _c("div", { staticClass: "input-group" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.setValue,
            expression: "setValue",
          },
        ],
        staticClass: "form-control input-sm frontendDatepicker",
        class: _vm.inputClass,
        attrs: {
          type: "text",
          autocomplete: "off",
          placeholder: _vm.placeholder,
          id: _vm.handle + "-" + _vm._uid,
          name: _vm.handle,
        },
        domProps: { value: _vm.setValue },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.setValue = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _vm._m(0),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-addon input-sm" }, [
      _c("i", { staticClass: "icon icon-calendar" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }